export default "__VITE_ASSET__BL7gz4W___"